import { css } from '@emotion/css';
import { Button } from '@volumental/common';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';

const submitButton = css`
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  padding-bottom: 5px;
`;

interface FeedbackButtonsProps {
  onSubmit: () => void;
  onSkip: () => void;
  isSubmitButtonDisabled?: boolean;
}

export function FeedbackButtons({
  onSkip,
  onSubmit,
  isSubmitButtonDisabled = false,
}: FeedbackButtonsProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={submitButton}>
      <div
        style={{
          width: '50%',
          paddingRight: '5px',
        }}
      >
        <Button
          backgroundColor="white"
          forgroundColor="black"
          showBorder
          onClick={onSkip}
        >
          {t('feedbackModal.skipSurveyBT')}
        </Button>
      </div>
      <div style={{ width: '50%', paddingLeft: '5px' }}>
        <Button onClick={onSubmit} disabled={isSubmitButtonDisabled}>
          {t('button.submit')}
        </Button>
      </div>
    </div>
  );
}
